import { Injectable, Injector } from '@angular/core';
import { ChassisFormHandler } from '../../forms/form/classes/form-handler';
import { Observable } from 'rxjs/Observable';
import { Model } from '../../api/model';

interface Data {
    [key: string]: any
};

@Injectable()
export class FormFactory {

    constructor(protected injector: Injector) {
    }

    public create(structure: string | Data, data: Data | Model | Observable<Model>, options: { [key: string]: any } = {}): ChassisFormHandler {
        return new ChassisFormHandler(
            this.injector, structure, data, options.name
        );
    }

}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/forms/services/form-factory.service.ts